import {
  createContext,
  type PropsWithChildren,
  useContext,
  useMemo,
} from "react";

interface NotificationRuleFormContextValue {
  isEditMode: boolean;
  ruleUUID?: string;
}

const NotificationRuleFormContext =
  createContext<NotificationRuleFormContextValue | null>(null);

export function useNotificationRuleFormContext(): NotificationRuleFormContextValue {
  const context = useContext(NotificationRuleFormContext);
  if (!context) {
    throw new Error(
      "useNotificationRuleFormContext must be used within a NotificationRuleFormContextProvider",
    );
  }
  return context;
}

interface Props extends NotificationRuleFormContextValue, PropsWithChildren {}

export function NotificationRuleFormContextProvider({
  isEditMode,
  ruleUUID,
  children,
}: Props) {
  const value = useMemo(
    () => ({ isEditMode, ruleUUID }),
    [isEditMode, ruleUUID],
  );
  return (
    <NotificationRuleFormContext.Provider value={value}>
      {children}
    </NotificationRuleFormContext.Provider>
  );
}
